export default __webpack_public_path__ + "static/media/Johannes_neutral.763135f4.jpg";